import React from "react";
import { BrowserRouter, Route, Switch } from "react-router-dom";

import Layout from "../components/Home/Layout";
import Home from "../views/Home";
import Producto from "../views/Product";
import SignUp from "../views/SignUp";
import Login from "../views/Login";
import Password from "../views/ChangePassword";
import MyProfile from "../views/MyProfile";
import RenewPassword from "../views/RenewPassword";
import PageNotFound from "../views/PageNotFound";
import SearchResults from "../views/SearchResults";
import Shop from "../views/Shop";
import OrderDetail from "../views/OrderDetail";
import { OrdersList } from "../views/OrdersList";
import OrderFlux from "../views/OrderFlux";
import { StepsProvider } from "../views/OrderFlux/Context";

const App: React.FC = () => {
  return (
    <BrowserRouter>
      <Layout>
        <Switch>
          <Route exact path="/" component={Home} />
          <Route exact path="/login" component={Login} />
          <Route exact path="/signup" component={SignUp} />
          <Route exact path="/search/:keyword/page/:pageNumber" component={Home} />
          <Route exact path="/search/:keyword" component={SearchResults} />
          <Route exact path="/product/:id" component={Producto} />
          <Route exact path="/perfil" component={MyProfile}/>
          <Route exact path="/renewPassword" component={RenewPassword}/>
          <Route exact path="/password" component={Password} />
          <Route exact path="/tienda" component={Shop} />
          <Route exact path="/orderDetail/:id?" component={OrderDetail} />
          <Route exact path="/orderslist" component={OrdersList} />
          <StepsProvider>
            <Route exact path="/checkoutprocess/:id?" component={OrderFlux} />
          </StepsProvider>
          <Route component={PageNotFound} />
        </Switch>
      </Layout>
    </BrowserRouter>
  );
};
export default App;
